module.exports = __webpack_public_path__ + "static/media/nav-close.6b1278a0.svg";